import { object, string } from "yup"
import { email } from "@/core/validation"

export default object({
  firstName: string().required("Required"),
  lastName: string().required("Required"),
  email,
})
